import 'jquery';



export const goToTop = (classElement, idElement) => {
    if(classElement !="" || idElement !="" ){
        let element :any= "";
        if(classElement != ""){
            element = $('.'+classElement)
        }else{
            element = $('#'+idElement)
        }

        let topPosition :number= 0;
        let e: any = element.offset();

        if( typeof e !== "undefined" && typeof e.top !== "undefined"){
            topPosition = parseInt(e.top)-130;
            if(topPosition < 0){
                topPosition = 0;
            }

        }

        element.fadeIn(300, function () {
            $('html, body').animate({
                scrollTop: topPosition
            }, 500, 'linear');
        });
    }

};









